<template>
  <ValidationObserver ref="orderValidation" tag="form" id="orderform">
    <b-form-group label="Dostawca:" label-for="provider" class="required">
      <b-form-select
        id="provider"
        v-model="form.provider"
        :options="providersList"
        required
      />
    </b-form-group>
    <b-form-group
      label="Adres dostawy:"
      label-for="addressList"
      class="required"
    >
      <b-form-select
        id="addressList"
        v-model="form.address"
        :options="getAddressList"
        required
      />
    </b-form-group>
    <b-form-group label="Planowana dostawa:" label-for="delivery_date">
      <v-date-picker
        class="datepicker"
        id="delivery_date"
        :masks="{ input: 'YYYY-MM-DD' }"
        :columns="$screens({ default: 1, md: 2 })"
        :popover="{ visibility: 'click' }"
        v-model="form.deliveryDate"
        :min-date="new Date()"
      />
    </b-form-group>
       <b-form-group label="Tür-Montagefutter:" label-for="mounting">
      <b-form-input
        type="text"
        id="mounting"
        v-model="form.mounting"
      ></b-form-input>
    </b-form-group>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-door-closed mr-2"></i>Drzwi</h3>
        <div>
          <b-button variant="outline-primary" size="sm" @click="createDoor()">
            <i class="fas fa-plus"></i> Dodaj
          </b-button>
        </div>
      </div>
      <div class="portlet-body">
        <b-table
          id="subconstructions-table"
          class="table table-list table-mobile m-0 "
          ref="subconstructions_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="doors"
          stacked="lg"
          show-empty
          empty-text="Brak drzwi"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:empty="{ emptyText }">
            <div class="empty">
              <i class="fas fa-door-closed empty-state"></i>
              <span class="empty-search">{{ emptyText }}</span>
            </div>
          </template>
          <template v-slot:cell(options)="data">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click="removeDoor(data.item)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </template>
        </b-table>
      </div>
    </div>
    <b-form-group label="Dodatkowe informacje:" label-for="notes">
      <b-form-textarea
        type="text"
        id="notes"
        v-model="form.notes"
        placeholder="Dodatkowe informacje..."
        rows="3"
        max-rows="10"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group label="Podgląd wiadomości, która zostanie wysłana do dostawcy:" label-for="preview" >
      <b-form-textarea
        type="text"
        id="preview"
        rows="10"
        max-rows="10"
        :value="previewContent"
        readonly
        hidden="true"
      >
      </b-form-textarea>
      <div v-html="previewContent" class="messagePreview"></div>
    </b-form-group>
    <DoorCreatorModalForm @onSubmit="addDoor" />
  </ValidationObserver>
</template>

<script>
import DoorCreatorModalForm from "@/components/notes/DoorCreatorModalForm";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "SupplierOrderDoorForm",
  components: { DoorCreatorModalForm },
  props: {
    order: { type: Object },
    orderid: { type: Number },
    constructionid: { type: Number },
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "height", label: "Wysokość" },
        { key: "width", label: "Szerokość" },
        { key: "thickness", label: "Grubość" },
        { key: "direction", label: "Kierunek" },
        { key: "lock", label: "Zamek" },
        { key: "type", label: "Typ" },
        { key: "model", label: "Rodzaj" },
        { key: "quantity", label: "Ilość" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
      providersList: [{ value: "u.wiehrdt@fries24.de", text: "Fries TÜR" }],
      form: {
        provider: "u.wiehrdt@fries24.de",
        mounting: "Ral 9016",
        deliveryDate: "",
        address: "",
        notes: "",

      },
      doors: [],
    };
  },
  computed: {
    ...mapGetters("construction", ["info", "manager"]),
    ...mapGetters("company", ["mainCompany"]),
    getAddressList() {
      var addressList = [
        { value: "", text: "--Wybierz adres dostawy--" },
        {
          value:
            "zu unserer Lager Barsbüttel Liefern. (" +
            this.mainCompany.address +
            ", " +
            this.mainCompany.postalcode +
            " " +
            this.mainCompany.city +
            ")",
          text:
            "Magazyn: " +
            this.mainCompany.address +
            ", " +
            this.mainCompany.postalcode +
            " " +
            this.mainCompany.city,
        },
        {
          value: "auf die Baustelle Liefern.",
          text: "Budowa: " + this.info.address,
        },
      ];
      return addressList;
    },
    listDoors() {
      var doors = "";
      for (let i = 0; i < this.doors.length; i++) {
        const element = this.doors[i];
        doors +=
          i +
          1 +
          ". " +
          element.height +
          "/" +
          element.width +
          "/" +
          element.thickness +
          "/" +
          element.direction +
          "/" +
          element.lock +
          "/" +
          element.type;

        if (element.window.type != null) {
          doors +=
            ", " +
            element.window.type +
            ", " +
            element.window.width +
            "mm" +
            "/" +
            element.window.height +
            "mm" +
            "/";
        } else {
          doors += "/";
        }
        doors += element.model + "\tx" + element.quantity + "<br/>";
      }

      return doors;
    },
    previewContent() {
      // const provider = this.form.provider ? this.form.provider : "";
      let html =
        "Hiermit bestellen wir für Bauvorhaben: <b>" +
        this.info.address +
        "</b><br/>" +
        "Tür-Montagefutter: <b>" +
        this.form.mounting +
        "</b><br/>" +
        "<br/>" +
        this.listDoors +
        "<br/>" +
        "Die Ware bitte -  " +
        this.form.address +
        "<br/>";

      if (this.form.deliveryDate) {
        html +=
          "Gewünschter Liefertermin " +
          dayjs(this.form.deliveryDate)
            .format("YYYY-MM-DD")
            .toString() +
          ".<br/>";
      }
      html +="<br/>";
      if(this.manager && this.manager.phone !== ''){
        html += "Verantwortlichen Bauleiter Herr " + this.manager.firstname + " " + this.manager.lastname + " erreichen Sie unter " + this.manager.phone + ".<br/>"
      } else if(this.manager) {
        html += "Verantwortlichen Bauleiter Herr " + this.manager.firstname + " " + this.manager.lastname + ".<br/>"
      }
      if (this.form.notes) {
        html += "<br/>" + this.form.notes.replace(/\n/g, "<br />") + "";
      }
      return html;
    },
  },
  methods: {
    onShow() {
      this.form.content = this.note.content;
    },
    getData() {
      return {
        type: "door",
        content: this.previewContent,
        address: this.form.address,
        email: this.form.provider,
      };
    },
    createDoor() {
      this.$nextTick(() => {
        this.$bvModal.show("doorCreator-modal");
      });
    },
    addDoor(door) {
      this.doors.push(door);
    },
    removeDoor(door) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm([h("p", "Czy napewno chcesz usunąć wskazane drzwi?")], {
          title: "Potwierdź usunięcie drzwi",
          okVariant: "danger",
          okTitle: "TAK",
          cancelTitle: "NIE",
        })
        .then((result) => {
          if (result !== true) {
            return;
          }
          var index = this.doors.indexOf(door);
          this.doors.splice(index, 1);
        });
    },
    onClose() {
      this.$emit("onClose");
    },
    cancel() {
      this.onClose();
    },
  },
};
</script>

<style>
.messagePreview{
  border: 1px solid #ced4da;
  padding: 6px 12px;
}
</style>
